import { HttpContextToken } from '@angular/common/http';

export const SHOW_ERROR = new HttpContextToken<boolean>(() => true);